import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as actions from './redux/actions'

import BannerNav from './BannerNav.js'

class Banner extends Component {
  static propTypes = {

  };
  componentDidMount() {
    this.props.actions.fetchDiscipline()
    this.props.actions.fetchMenuList()

    this.props.actions.fetchGetHomeHotRecommend();
  }
  render() {
    const { discipline = [], menuList = [] } = this.props
    return (
      <div className="home-banner">
        <BannerNav menuList={menuList} disciplineList={discipline} />
        
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    menuList: state.home.menuList,
    discipline: state.home.discipline
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Banner)


// WEBPACK FOOTER //
// ./src/features/home/Banner.js